import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';
import { UserTypes, UserTypesIcon } from '../../../common/enums';

@Component
class SearchSelectedItemComponent extends Vue {

  @Prop({ default: () => { }, type: [Object, Number] })
  selectedItem: any;

  @Prop({ default: null, type: [String] })
  iconName: string;
  @Prop({ default: null, type: [Number] })
  index: number | null;
  @Prop({ default: 'text', type: [String] })
  itemText: string

  get coIcon(): string {

    if (this.iconName) return this.iconName;

    switch (this.selectedItem.type) {
      case UserTypes.SuperAdmin:
        return 'stars'
      // case UserTypes.ManagerAdmin:
      case UserTypes.Manager:
      case UserTypes.SalesPerson:
        return UserTypesIcon.ManagerIcon;
      case UserTypes.MaintenanceReferent:
      case UserTypes.VehicleReferent:
        return UserTypesIcon.ManagerBasicIcon
      // case UserTypes.caretaker2:
      case UserTypes.Caretaker:
      case UserTypes.IndependentContractor:
      case UserTypes.InternalContractor:
      case UserTypes.ExternalProvider:
      case UserTypes.ExternalProviderMember:
        return UserTypesIcon.IndependentContractorIcon;
      case UserTypes.Owner:
      case UserTypes.PlusUser:
        return UserTypesIcon.OwnerIcon;
      case UserTypes.Tenant:
      case UserTypes.Customer:
      case UserTypes.SimpleUser:
        return UserTypesIcon.TenantIcon;
      default:
        return null;
    }
  }

  get coLabel(): string {
    return this.selectedItem[this.itemText] || this.selectedItem.firstname + ' ' + this.selectedItem.lastname;
  }

  @Emit('remove')
  handleRemove (event) {}
}

export default SearchSelectedItemComponent;



// WEBPACK FOOTER //
// ./src/components/multi-select/search-selected-item/index.ts